var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBdFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.08203,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3814_67902",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 25,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.08203,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3814_67902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.08203,
    width: 24,
    height: 17.1429,
    fill: "#128363"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.3572,
    cy: 12.6531,
    rx: 5.14286,
    ry: 5.14286,
    fill: "#F23C53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdFlag);
export default __webpack_public_path__ + "static/media/bd-flag.a814b1e64b20b9599c9690f2b4f675b1.svg";
export { ForwardRef as ReactComponent };